import { Box, LinearProgress, SxProps, Theme } from '@mui/material';
import { FC } from 'react';
import {
  DECATHLON_GREY_COLOR,
  SHARE_LOGO_BLUE_COLOR
} from '../../constants/colors';
import MyTheme from '../../theme/MyTheme';

const sxStyles: Record<string, SxProps<Theme>> = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: MyTheme.spacing(3),
    animation: 'splash-fade-in 400ms ease-out',
    '@keyframes splash-fade-in': {
      from: { opacity: 0 },
      to: { opacity: 1 }
    },
    '@media (prefers-reduced-motion: reduce)': {
      animation: 'none'
    }
  },
  logo: {
    width: 180
  },
  progress: {
    width: 180,
    height: 3,
    borderRadius: 3,
    backgroundColor: DECATHLON_GREY_COLOR,
    '& .MuiLinearProgress-bar': {
      borderRadius: 3,
      backgroundColor: SHARE_LOGO_BLUE_COLOR
    }
  }
};

const AppSplash: FC = () => {
  return (
    <Box sx={sxStyles.container}>
      <Box
        component="img"
        alt="Share"
        src={`${process.env.PUBLIC_URL}/ShareLogo.svg`}
        sx={sxStyles.logo}
      />
      <LinearProgress sx={sxStyles.progress} aria-label="Loading" />
    </Box>
  );
};

export default AppSplash;
